module.exports = __webpack_public_path__ + "img/mc-r-r1.cdb90840.gif";